export default "__VITE_ASSET__3d2e6d35__"